// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"96dcf2f4","320":"2698738d","453":"3b158237","905":"61bc0998"}[chunkId] + ".chunk.js";
};